/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from 'react'
import { connect, useDispatch,useSelector } from 'react-redux'
import FileBase64 from 'react-file-base64';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

import PropTypes, { object } from 'prop-types';
import clsx from 'clsx'
import moment from 'moment';
// import {  } from "@material-ui/core";
import { Modal, Dialog, DialogTitle, DialogContent, DialogActions, Box, TextField, Grid, FormGroup, IconButton } from '@material-ui/core'; // Remove the unused imports for CHG0073013
import { useHistory } from 'react-router-dom';
import InputAdornment from '@material-ui/core/InputAdornment';
import { SearchOutlined } from '@material-ui/icons';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ClearIcon from '@mui/icons-material/Clear';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { MdReplay } from 'react-icons/md';
import styles from './ReportTMLMORForm.module.css'
import { CustomDatePicker, CustomFormGroup, CustomSelect, ValidatingTextField } from '../FormComponents'
import { DATE_FORMAT, API_RESOURCE_URLS, DISPLAY_MESSAGES, MESSAGE_TYPE, RESOURCE_TYPE, USER_OPERATIONS, Regex } from '../../constants'
import { API } from '../../apis/api'
import TextIcon from './TextIcon'
import { buildErrorMessage } from '../../apis/calls'
import Table from '../Table/Table';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { AuthChecker, Button } from '../../atomicComponents';
import { withAllowedOperationsProvider } from '../../hocs'
import { setToast, setPORow, poSearch, fetchChassis, setChassisData, setAllDetails, getInvoice } from '../../redux/actions/productsActions';
import  TableSimple from '../../atomicComponents/TableSimple/TableSimple';
import { setLogin } from '../../redux/features/auth/actions';
import Truckloading from "../CvLoader/Cvloader";
import ReportTable from '../ReportTableComponent/ReportTable';
import { sanitizeCoCodeNumeric } from '../../utils/utils';

const initialState = {
  plant: null,
  part: null,
  aqCommodity: null,
  purchaseCommodity: null,
  supplierCode: null,
  supplierDetails: null,
  supplierName: '',
  supplierLocation: '',
  selectedProject: null,
  selectedPO: null,
  inputFields: {
    purchaseBuyerName: '',
    suppRepresentativeName: '',
    suppRepresentativeContact: '',
    suppRepresentativeEmail: ''
  },
  errors: {},
}
const reducer = (state, action) => {
  switch (action.type) {
    case 'update':
      return {
        ...state,
        [action.field]: action.value
      }
    case 'reset':
      return {
        ...state,
        ...initialState
      }
    default:
      return state
  }
}

function ReportTMLMORForm() {
  const dispatchNew= useDispatch();
  const ROW_HEIGHT = 38;
  const [rowsData, setRowsData] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  const [poData, setPOData] = useState({
    loading: false,
    data: [],
    filteredData: [],
    last: false,
    number: 0
  });
  

  const [state, dispatch] = useReducer(reducer, initialState);
  const { showInternalError } = usePopupManager();
  const { showPopup } = usePopupManager();
  const dispatch1 = useDispatch();
  const history = useHistory();
  const auth = useSelector((state) => state.auth); // useSelector
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  let {
    userName,
    personNumber,
    companyCode,
    userRole,
    } = auth;
    let requiredUsers= "SA";
    const userList = userRole.filter(role => requiredUsers.includes(role));
    console.log(userList,userList.length);
  const { damage, invoice, plant, part, aqCommodity, purchaseCommodity, supplierCode, supplierDetails, supplierName,
    supplierLocation, selectedProject, selectedPO, inputFields, errors } = state;


  const [suppliers, getSuppliers] = useState({ loading: false, data: [] });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmModalFlag, setConfirmModal] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [deleteParam, handleDeleteParam] = useState();
  const [deleteParam2, handleDeleteParam2] = useState();
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] = useState(false);
  const [tableArray, setTableArray] = useState([]);
  const [allTableData,setAllTableData]=useState([]);
  const [viewDisplay, setViewDisplay] = useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [toggle, setToggle] = React.useState(false);
  const [loader, setLoader] = React.useState(true);
  const [hover, setHover] = useState({ isHover: false, name: null });
  const [bodyBuilderOption, setBdybuilderOption] = useState([]);
  const [chassisOption, setChassisData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
  const [loadings, setLoadings] = React.useState(false);

  const [companyCodeOption, setCompanyCode] = useState([]);

  const HEIGHT = '300px';
  const FILENAME = 'TML_EOR_Report';

  const [myState, setState] = React.useState(
    {
      poNo: "",
      stmNo: "",
      chassisNo: null,
      toDate: null,
      fromDate: null,
      bodyBuilder: null,
      checkFlag: false

    });

  const setCount = count => {
    setAsnCount(count);
  };
 
  useEffect(() => {
    setViewDisplay(true);
    setRowsPerPage(10)
    setPage(0)
    setLoadings(true);
    if (userRole.includes("SA")) {
      userRole = "SA";
    } 
    
      let apiFormatedData = {
        // "pers_no": personNumber
        "co_code": sanitizeCoCodeNumeric(companyCode),
      };
    let apiFormatedDataJson = JSON.stringify(apiFormatedData);
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
      fetch(`${baseUrl}reports/TMLMORReport`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:"include"
      })
      .then((response) => {
       
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoadings(false);
        }
        return response.json();
        })
      .then((responseJson) => {
       
        if (responseJson.msg=="Success" && responseJson.data.length != 0) {
          setLoadings(false);
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setAllTableData(finalList)
          setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
         
        }
        else if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
          setLoadings(false);
          setAllTableData([]);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
        })
        }
        else if(responseJson && responseJson.msg=="Fail")  {
          setLoadings(false);
          setAllTableData([]);
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: responseJson.data,
        })
        }
      }).catch((error) => {
        setLoadings(false);
        setAllTableData([]);
        if (error.response) {
          showPopup({
                  type: MESSAGE_TYPE.FAILURE,
                  contextText: MESSAGE_TYPE.FAILURE,
                  info: "Oops! Something went wrong. Please try again later. Please try again later",
              })
        }
        else {
          showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "There might be Network issue, please try after some time",
            })
        }
      });

    
  }, []);
 
  const BG_COLOR = '#fffef8';
  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } = backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors(prev => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field)
          newBackgroundColors[key] = true;
        else
          newBackgroundColors[key] = false;
      }
      return newBackgroundColors
    })

  const handleOpen = () => setIsPopupOpen(true);
  const handleClose = () => setIsPopupOpen(false);
  const handleOpen1 = () => {
    setConfirmModal(true);


  };
  const handleOpen2 = () => {
    setConfirmModal2(true);


  };
  const handleClose2 = () => setConfirmModal2(false);
  const resetFields = () => {
    if(myState.checkFlag==true){
      setState((prevData) => ({
        ...prevData, 
        chassisNo: null,
        toDate: null,
        fromDate: null,
      }));
    } else {
      setState((prevData) => ({
        ...prevData, 
        chassisNo: null,
        toDate: null,
        fromDate: null,
        bodyBuilder: null,
      }));
    }
 
    setTableData([])
    setHighlightMandatoryFields(false)

  }

 

  const baseDefaultColumns = [
    {
      width: 100,
      title: 'BC No',
      field: 'bc_number',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 160,
      title: 'BC Name',
      field: 'bc_name',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 80,
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      title: 'BC Bookable Status',
      field: 'bc_bookable_status',
      enableSearch: true,
      enableFilter: true,
    }, 
    { 
      width: 90,
      title: 'EMP No',
      field: 'pers_no',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 180,
      title: 'EMP Name',
      field: 'complete_name',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 100,
      title: 'Gender',
      field: 'gender',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 140,
      title: 'Date Of Birth',
      field: 'date_of_birth',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 140,
      title: 'Date Of Join',
      field: 'date_of_join',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 100,
      title: 'Manager1 Id',
      field: 'manager1_id',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 160,
      title: 'Manager1 Name',
      field: 'manager1_name',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 100,
      title: 'Manager2 Id',
      field: 'manager2_id',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 180,
      title: 'Manager2 Name',
      field: 'manager2_name',
      enableSearch: true,
      enableFilter: true,
    },  
    { 
      width: 90,
      title: 'EMP Bookable Status',
      field: 'emp_bookable_status',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 80,
      title: 'Grade',
      field: 'grade',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 80,
      title: 'Grade Group',
      field: 'grade_group',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 120,
      title: 'Workarea',
      field: 'workarea',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 140,
      title: 'Company',
      field: 'company',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 100,
      title: 'Location',
      field: 'location',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 130,
      title: 'Emp Status',
      field: 'emp_status',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 122,
      title: 'Grddetails',
      field: 'grddetails',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 150,
      title: 'Design',
      field: 'design',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 150,
      title: 'Title',
      field: 'title',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 150,
      title: 'Role 1',
      field: 'role1',
      enableSearch: true,
      enableFilter: true,
    },
  ];

  const renderReport = () => (
    <div
      className={styles.formGroup}>
        <Grid
            container
            spacing={1}
            // className={styles.myGrid}
            style={{ marginTop: "10px" }}
            columns={12}
          >
             
            <Grid item md={12} lg={12} xs={12} sm={10}>
              <div className={styles.formDiv}>
      <div
      //  className={styles.customeTable}
        className={styles.col2}
         style={{
          width: "100%",
          height: "100%",
        }}
      >
        <ReportTable columns={baseDefaultColumns} data={allTableData} height={HEIGHT} fileName={FILENAME}/>
        
        
      </div>
      </div>
      </Grid>
      </Grid>

    </div>)



  const getSelectedFields = () => ({
    projectId: selectedProject,
    poNumber: selectedPO,
    commodityGroupId: purchaseCommodity && purchaseCommodity.value,
    aqCommodityGroupId: aqCommodity && aqCommodity.value,
    purchaseBuyerName: inputFields?.purchaseBuyerName,
    kamContactDetails: {
      // id: inputFields,
      name: inputFields?.suppRepresentativeName,
      contactNumber: inputFields?.suppRepresentativeContact,
      emailId: inputFields?.suppRepresentativeEmail
    }
  });

  const validateFields = (fields) => {
    const requiredFields = { ...fields, ...fields.kamContactDetails }
    const hasMissingRequiredFields = Object.values(requiredFields).some(
      (field) => !field
    );

    const hasError = Object.values(errors).some((err) => err);

    if (hasMissingRequiredFields || hasError) {
      return false;
    }
    return true;
  };

  const runPreSubmissionChecks = () => {
    const selectedFields = getSelectedFields();
    const areFieldsValid = validateFields(selectedFields);

    if (!areFieldsValid) {
      setHighlightMandatoryFields(true);
      // return false;
      return true;
    }
    return true;
  };







  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: '',
      suppRepresentativeName: '',
      suppRepresentativeContact: '',
      suppRepresentativeEmail: ''
    }
    dispatch({ type: 'update', field: 'inputFields', value: inputs });
    dispatch({ type: 'update', field: 'errors', value: {} });
  }

  const resetState = () => {
    dispatch({ type: 'reset' });
    resetAllInputs();
    resetTableData();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor('processInfoBg');
  }



  useEffect(() => {
    if (resetAllVisitedFields)
      resetState();
  }, [resetAllVisitedFields])









  return (
    <>
      <div className={clsx(styles.scrollContainer, styles.scrollBar, styles.formContainer)}>


        {tableData.length === 0 && (
      <>
     <CustomFormGroup header='TML EOR Report' body={renderReport()} /> 
    
     </>

        )}
         {loadings ? (
        <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
             <Truckloading />
          </div>):""}




      </div>

    

      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />

      <ResetModal2
        a={confirmModalFlag2}
        handleCase={handleClose2}
        onDelete={() => onDeleteRow2(deleteParam2)}
      />


    </>
  )
}


function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Do you want to delete ?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleCase}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Do you want to delete ?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleCase}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Are you sure you want to reset the filters?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleClose}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose()
              resetFields()
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

ReportTMLMORForm.propTypes = {
  redirectToProcessPage: PropTypes.func
}

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired
}
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}
ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
const mapDispatchToProps = (dispatch) => ({

  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
ReportTMLMORForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(ReportTMLMORForm);


export default withAllowedOperationsProvider(
  App,
  RESOURCE_TYPE.PPAP
);